// import React, { useEffect, useState } from "react";
// import { Navigate } from "react-router-dom";
// import { validateToken } from "./validateToken.js";
// import { getCookie } from "./webStorage.js";
// import { useUser } from "./userProvider.js";
// import { InfiLoader } from "../components/loader.js";

// const ProtectedRoute = ({ element: Element }) => {
//   const { setUser, permissions } = useUser();
//   const [isValidated, setIsValidated] = useState(false);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const token = getCookie("sctoken");
//     // console.log("token",token);
//     console.log("token", token);
//     if (!token) {
//       window.location.href = "/";
//     }

//     validateToken(token)
//       .then((user) => {
//         console.log("user PrivateRoute", user);
//         if (user?.success === true) {
//           setIsValidated(true);
//           setUser(user?.user);
//         } else {
//           setIsValidated(false);
//         }
//       })
//       .catch((error) => {
//         console.error("Token validation failed:", error);
//         setIsValidated(false);
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   }, []);

//   if (loading) {
//     return <InfiLoader maintext="Verifying.." />;
//   }
//   return isValidated ? <>{Element}</> : <Navigate to="/" />;
// };

// export default ProtectedRoute;

// import React, { useEffect, useState } from "react";
// import { Navigate } from "react-router-dom";
// import { validateToken } from "./validateToken.js";
// import { getCookie } from "./webStorage.js";
// import { useUser } from "./userProvider.js";
// import { InfiLoader, SuwasthiLoader } from "../components/loader.js";
// import { hasAnyPermission } from "./permissions.js";

// const ProtectedRoute = ({ children, resource, actions }) => {
//   const { setUser, userData, permissions, } = useUser();
//   const [isValidated, setIsValidated] = useState(false);
//   const [loading, setLoading] = useState(true);

//   console.log("protected route permissions", children,resource, actions);

//   useEffect(() => {
//     const token = getCookie("swtoken");
//     if (!token) {
//       window.location.href = "/";
//       return;
//     }

//     validateToken(token)
//       .then((user) => {
//         if (user?.success) {

//           // console.log("🛂 User Data from API:", user.data);
//           // console.log("🔑 Permissions from API:", user.data.permissions);
          
//           setUser(user.data);
//           setIsValidated(true);
          
//         } else {
//           setIsValidated(false);
//         }
//       })
//       .catch((error) => {
//         console.error("Token validation failed:", error);
//         setIsValidated(false);
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   }, []);

//   if (loading) {
//     return <SuwasthiLoader maintext="Verifying.." />;
//   }

//   if (!isValidated) {
//     return <Navigate to="/" />;
//   }

//   // 🚀 Check if user has at least one required permission
//   if (!hasAnyPermission(permissions, resource, actions)) {
//     return <Navigate to="/unauthorized" />;
//   }

//   return children;
// };

// export default ProtectedRoute;



import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { validateToken } from "./validateToken.js";
import { getCookie } from "./webStorage.js";
import { useUser } from "./userProvider.js";
import { SuwasthiLoader } from "../components/loader.js";
import { hasAnyPermission } from "./permissions.js";

const ProtectedRoute = ({ children, resource, actions }) => {
  const { setUser, userData, permissions } = useUser();
  const [isValidated, setIsValidated] = useState(false);
  const [loading, setLoading] = useState(true);
    const location = useLocation(); 

  useEffect(() => {
    const token = getCookie("swtoken");


    // if (!token) {
    //   window.location.href = "/";
    //   return;
    // }

       if (!token) {
      // ✅ Redirect to login with redirect query
      const redirectUrl = encodeURIComponent(location.pathname + location.search);
      window.location.href = `/?redirect=${redirectUrl}`;
      return;
    }

    validateToken(token)
      .then((user) => {
        if (user?.success) {
          setUser(user.data);
          setIsValidated(true);
        } else {
          setIsValidated(false);
        }
      })
      .catch((error) => {
        console.error("Token validation failed:", error);
        setIsValidated(false);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <SuwasthiLoader maintext="Verifying..." />;

  if (!isValidated) return <Navigate to="/" />;

  // ✅ Make sure we use the latest permissions from userData if not directly from context
  const userPermissions = permissions || userData?.permissions || [];

  // ✅ Check for required permission
  const isAuthorized = hasAnyPermission(userPermissions, resource, actions);

  if (!isAuthorized) return <Navigate to="/unauthorized" />;

  return children;
};

export default ProtectedRoute;
